import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navbar5.css";

const NAV_ITEMS = [
  { path: "/",           label: "Home" },
  { path: "/about",      label: "About" },
  {
    path: "/services",
    label: "Services",
    dropdown: [
      { path: "/services/mobile-solutions",      label: "Mobile Solutions" },
      { path: "/services/testing",               label: "Testing" },
      { path: "/services/enterprise-solutions",  label: "Enterprise Solutions" },
      { path: "/services/business-intelligence", label: "Business Intelligence" },
      { path: "/services/data-science",          label: "Data Science" },
      { path: "/services/data-entry",            label: "Data Entry" },
    ],
  },
  { path: "/products",   label: "Products" },
  { path: "/case-study", label: "Case Study" },
  { path: "/blogs",      label: "Blogs" },
  { path: "/career",     label: "Careers" },
];

const LocationIcon = () => (
  <svg width="9" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
  </svg>
);
const PhoneIcon = () => (
  <svg width="9" height="9" viewBox="0 0 24 24" fill="currentColor">
    <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/>
  </svg>
);
const EmailIcon = () => (
  <svg width="9" height="8" viewBox="0 0 24 18" fill="currentColor">
    <path d="M22 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V2l8 5 8-5v2z"/>
  </svg>
);
const ChevronIcon = ({ className }) => (
  <svg className={className} width="8" height="5" viewBox="0 0 10 6" fill="none">
    <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
const FbIcon  = () => <svg width="9" height="17" viewBox="0 0 12 22" fill="currentColor"><path d="M8.73 3.93C9.67 3.93 11.25 3.93 11.25 3.93V.72S8.67.72 8.67.72C5.04.72 3.64 3.5 3.64 5.04V7.73H.89V11.05H3.64V21.45H7.62V11.11H10.84L11.25 7.78H7.62V5.10S7.80 3.93 8.73 3.93Z"/></svg>;
const IgIcon  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>;
const LiIcon  = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>;

function Navbar5() {
  const [menuOpen,     setMenuOpen]     = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [scrolled,     setScrolled]     = useState(false);
  const navigate  = useNavigate();
  const location  = useLocation();

  useEffect(() => {
    setMenuOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 46);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const goTo     = (path) => { navigate(path); setMenuOpen(false); };

  const isActive = (path) => {
    const currentPath = location.pathname.toLowerCase();

    if (
      currentPath.includes("aboutvision") ||
      currentPath.includes("aboutmission") ||
      currentPath.includes("aboutpassion") ||
      currentPath === "/about"
    ) {
      return path === "/about";
    }

    if (currentPath.includes("product")) {
      return path === "/products";
    }

    if (currentPath === "/") {
      return path === "/";
    }

    return currentPath === path;
  };

  return (
    <>
      {/* ===== TOPBAR ===== */}
      <div className={`nb-topbar${scrolled ? " nb-topbar--hidden" : ""}`}>
        <div className="nb-topbar__inner">
          <ul className="nb-topbar__info">
            <li>
              <span className="nb-topbar__chip"><LocationIcon /></span>
              Global Suntec Solutions Pvt. Ltd., Infront Of Commerce Zone IT Park, Pune 411006 MH, INDIA
            </li>
            <li>
              <span className="nb-topbar__chip"><PhoneIcon /></span>
              +91 - 9511877603
            </li>
            <li>
              <span className="nb-topbar__chip"><EmailIcon /></span>
              info@gsuntec.com
            </li>
          </ul>

          <ul className="nb-topbar__social">
            <li>
              <a href="https://www.facebook.com/gsuntec2023----" target="_blank" rel="noreferrer" aria-label="Facebook" className="nb-soc-btn">
                <FbIcon />
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/gsuntec_2024?igsh=YzljYTk1ODg3Zg==" target="_blank" rel="noreferrer" aria-label="Instagram" className="nb-soc-btn">
                <IgIcon />
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/company/global-suntec-solutions/posts/?feedView=all" target="_blank" rel="noreferrer" aria-label="LinkedIn" className="nb-soc-btn">
                <LiIcon />
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* ===== MAIN NAVBAR ===== */}
      <nav className={`nb-navbar${scrolled ? " nb-navbar--sticky" : ""}`}>
        <div className="nb-navbar__inner">

          <div className="nb-logo" onClick={() => goTo("/")}>
            <img src="/images/logo.png" alt="Global Suntec Solutions" />
            <div className="nb-logo__divider" />
            <div className="nb-logo__text">
              <span className="nb-logo__name">Global Suntec</span>
              <span className="nb-logo__sub">Solutions Pvt. Ltd.</span>
            </div>
          </div>

          <ul className="nb-menu">
            {NAV_ITEMS.map((item) => (
              <li key={item.path} className={`nb-item${item.dropdown ? " nb-item--drop" : ""}`}>
                <span
                  className={`nb-link${isActive(item.path) ? " nb-link--active" : ""}`}
                  onClick={() => goTo(item.path)}
                >
                  {item.label}
                  {item.dropdown && <ChevronIcon className="nb-chevron" />}
                </span>

                {item.dropdown && (
                  <ul className="nb-dropdown">
                    {item.dropdown.map((sub) => (
                      <li key={sub.path}>
                        <span className="nb-dropdown__link" onClick={() => goTo(sub.path)}>
                          <span className="nb-dropdown__dot" />
                          {sub.label}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
          
          <button className=" nb-cta nb-cta--demo" onClick={() => goTo("/contact-us")}>
            <span> <i className = "bi bi-calendar2-check-fill me-2"></i>Request a Demo</span>
          </button>
          <button className="nb-cta" onClick={() => goTo("/contact-us")}>
            <span>Contact Us →</span>
          </button>
          

          <button
            className={`nb-burger${menuOpen ? " nb-burger--open" : ""}`}
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>
        </div>

        {/* Mobile drawer */}
        <div className={`nb-drawer${menuOpen ? " nb-drawer--open" : ""}`}>
          <ul className="nb-drawer__list">
            {NAV_ITEMS.map((item) => (
              <li key={item.path} className="nb-drawer__item">
                {item.dropdown ? (
                  <>
                    <span
                      className="nb-drawer__link nb-drawer__link--toggle"
                      onClick={() => setServicesOpen((v) => !v)}
                    >
                      {item.label}
                      <ChevronIcon className={`nb-drawer__chevron${servicesOpen ? " nb-drawer__chevron--open" : ""}`} />
                    </span>
                    {servicesOpen && (
                      <ul className="nb-drawer__sub">
                        {item.dropdown.map((sub) => (
                          <li key={sub.path}>
                            <span className="nb-drawer__sublink" onClick={() => goTo(sub.path)}>
                              {sub.label}
                            </span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <span
                    className={`nb-drawer__link${isActive(item.path) ? " nb-drawer__link--active" : ""}`}
                    onClick={() => goTo(item.path)}
                  >
                    {item.label}
                  </span>
                )}
              </li>
            ))}
            
            <li className="nb-drawer__item">
              <span className=" me-2 nb-drawer__cta" onClick={() => goTo("/contact-us")}>
                <i class="bi bi-calendar-check-fill"></i>Request a Demo
              </span>
            </li>
            <li className="nb-drawer__item">
              <span className="nb-drawer__cta" onClick={() => goTo("/contact-us")}>
                Contact Us →
              </span>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default Navbar5;